import { Box, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";

import { CustomButton, DefaultLoader } from "../../components";
import { images } from "../../constants";
import { ordinal } from "../../utils/functions/ordinal";

const AutoDepositSuccess = props => {
  const { history, rspDetail, loadingRspDetail } = props;

  if (loadingRspDetail) return <DefaultLoader />;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: "100vh",
      }}
    >
      {/* logo */}
      <Box sx={{ marginTop: "16px", marginLeft: "16px" }}>
        <img src={images.principalLogo} alt="principal-logo" />
      </Box>

      {/* Submitted text */}
      <Box sx={{ margin: "24px 16px" }}>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "700",
            color: "#00A29B",
            marginBottom: "16px",
          }}
        >
          Monthly auto Cash In submitted for processing...
        </Typography>
        <Typography color="textPrimary" sx={{ marginBottom: "16px" }}>
          Your monthly auto Cash In request will be processed within 2 business
          days. Thank you.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <Typography color="textPrimary">Auto Cash In date</Typography>
          <Typography color="textPrimary">
            {ordinal(Number(rspDetail.dateOfMonth)) + " of each month"}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 0 24px",
            borderBottom: "1px solid #9d9ea4",
          }}
        >
          <Typography color="textPrimary">Auto Cash In amount</Typography>
          <Typography color="textPrimary">
            RM{" "}
            <NumberFormat
              value={rspDetail.amount}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Box>
      </Box>

      {/* Submitted details */}
      <Box style={{ margin: "0 16px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <Typography color="textPrimary">Cash In Via</Typography>
          <Typography color="textPrimary">FPX Online Banking</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <Typography color="textPrimary">Date</Typography>
          <Typography color="textPrimary">
            {moment().format("DD MMM YYYY")}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <Typography color="textPrimary">Time</Typography>
          <Typography color="textPrimary">
            {moment().format("hh:mm:ss A")}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <Typography color="textPrimary">Reference Number</Typography>
          <Typography color="textPrimary">12094PMD100011</Typography>
        </Box>
      </Box>

      {/* Button */}
      <Box
        sx={{
          bottom: "0",
          padding: "16px 16px 24px",
          position: "sticky",
          marginTop: "auto",
        }}
      >
        <CustomButton
          text="Next"
          variant="contained"
          color="#fff"
          backgroundColor="#1278cc"
          onClick={() => history.push("/dashboard")}
        />
      </Box>
    </Box>
  );
};

const withConnect = connect(state => ({
  withdrawalResult: state.goal.withdrawalResult,
  ...state.autoDepositReducer,
}));

export default compose(
  withRouter,
  withConnect
)(AutoDepositSuccess);
